import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {BankStatementContainerModel} from '../../../../../../models/aggregates/erp/index';

@Injectable({
    providedIn: 'root'
})
export class BankStatementService extends BaseApiTemplateService<BankStatementContainerModel> {
    //https://api.akaun.cloud/core2/tnt/dm/erp/bank-statement
    readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/bank-statement'

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/bank-statement';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/bank-statement';
        this.httpClient = http;
    }
    
}

